import { Component, inject, Input, input, OnInit, output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanPlasticSign } from "@domain/project/floorplan/floorplan-plastic-sign";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";
import { FloorplanPlasticSignDetailFormComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-plastic-sign-detail-form/floorplan-plastic-sign-detail-form.component";
import { FloorplanItemGroupComponent } from "@project/floorplanner/floorplan-item-group/floorplan-item-group.component";
import { ProjectStateService } from "@project/project-state.service";
import { Observable } from "rxjs";

@Component({
  selector: " app-plastic-sign-notes",
  templateUrl: "./plastic-sign-notes.component.html",
  styleUrls: ["./plastic-sign-notes.component.scss"],
  imports: [UiKitModule, FloorplanItemDetailsComponent, FloorplanItemGroupComponent, FloorplanPlasticSignDetailFormComponent],
  standalone: true,
})
export class PlasticSignNotesComponent implements OnInit {
  private projectStateService = inject(ProjectStateService);

  @Input({ required: true }) set floorplanItem(item: FloorplanItem) {
    this.plasticSign = item as FloorplanPlasticSign;
  }
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();

  protected plasticSign!: FloorplanPlasticSign;
  protected isDiscontinued$!: Observable<boolean>;
  protected readonly SidesheetExtent = FloorplanSidesheetExtent;

  ngOnInit() {
    this.isDiscontinued$ = this.projectStateService.isConfigDiscontinued(this.plasticSign.config.id);
  }
}
